import { React, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/images/GROTrackTurquoise.png";
import AdminSidebar from "../components/AdminSidebar";
import Loading from "../views/Loading";
import { useUserContext } from "../contexts/userContext";
import { getLogo } from "../utlis/themeHelpers";
import AdminHeader from "../components/AdminHeader";
import { useTranslation } from "../contexts/TranslationContext";

export default function AdminMedication() {
  const [editMode, setEditMode] = useState(false);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState("");
  const [ready, setReady] = useState(false);
  const { isSalonApp } = useUserContext();
  const { translate } = useTranslation()

  const [medications, setMedications] = useState([]);
  const [newMedication, setNewMedication] = useState({
    name: "",
    brand: "",
    dosage: "",
    fee: "",
  });
  const [editMedication, setEditMedication] = useState(null);

  const fetchMedications = () => {
    fetch(`${process.env.REACT_APP_API}/clinic/medications`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          setMedications(response.medications);
        } else {
          setMessage(response.message);
        }
      })
      .catch((error) => {
        console.error(error);
        setMessage(translate('error_occurred'));
      })
      .finally(() => setReady(true));
  };

  const handleSubmit = () => {
    if (editMode) {
      setReady(false);
      fetch(
        `${process.env.REACT_APP_API}/clinic/medications/${editMedication.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(editMedication),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.success) {
            setEditMode(false);
            setEditMedication(null);
            setSuccess(translate('medication_saved_successfully'));
            fetchMedications();
          } else {
            setMessage(response.message);
          }
        })
        .catch((error) => {
          console.error(error);
          setMessage(translate('error_occurred'));
          setReady(true);
        });
    } else {
      setReady(false);
      fetch(`${process.env.REACT_APP_API}/clinic/medications`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify(newMedication),
      })
        .then((response) => response.json())
        .then((response) => {
          setSuccess(translate('New medication added successfully'));
          setNewMedication({
            name: "",
            brand: "",
            dosage: "",
            fee: "",
          });
          if (response.success) {
            setSuccess(translate('new_medication_added_successfully'));
            fetchMedications();
          } else {
            setMessage(response.message);
          }
        })
        .catch((error) => {
          console.error(error);
          setMessage(translate('error_occurred'));
          setReady(true);
        });
    }
  };

  useEffect(() => {
    fetchMedications();
  }, []);

  useEffect(() => {
    if (editMedication) setEditMode(true);
  }, [editMedication]);

  return (
    <>
      <main
        className={`mx-auto container flex flex-col p-5 pb-12 font-font-2 tracking-wider ${
          ready ? "" : "hidden"
        }`}
      >
        <AdminHeader physician={{}} />

        {message && <p className="mt-8 text-center text-red-600">{message}</p>}
        {success && (
          <p className="mt-8 text-center text-green-600">{success}</p>
        )}
        <section className="flex px-5">
          <AdminSidebar />
          <div className="mx-auto">
            <form
              className="mt-4 flex flex-col"
              onSubmit={(event) => {
                event.preventDefault();
                handleSubmit();
              }}
            >
              <div className="flex justify-between items-center">
                <button
                  type="button"
                  className={`px-8 py-1 bg-background-23 rounded-lg text-text-3 font-bold
              cursor-pointer focus:outline-none ${!editMode && "hidden"}`}
                  onClick={() => {
                    setEditMode(false);
                    setEditMedication(null);
                  }}
                >
                  {translate('cancel')}
                </button>
                <p className="mx-24 text-text-2">{translate('set_up_medication')}</p>
                <button
                  className="px-8 py-1 bg-background-23 rounded-lg text-text-3 font-bold
              cursor-pointer focus:outline-none"
                >
                  {editMode ? translate('save') : translate('add')}
                </button>
              </div>
              <div className="mx-auto mt-10 flex flex-col items-end">
                <div
                  className={`w-full md:w-96 px-2 ${editMode ? "" : "hidden"}`}
                ></div>
                <label className="mt-4 flex items-center">
                  <p className="ml-2">{translate('medication')}</p>
                  <input
                    type="text"
                    className="ml-6 w-40 md:w-96 px-2 py-1 bg-background-2 text-text-2 font-bold rounded-sm focus:outline-none"
                    value={editMode ? editMedication.name : newMedication.name}
                    onChange={(event) => {
                      editMode
                        ? setEditMedication({
                            ...editMedication,
                            name: event.target.value,
                          })
                        : setNewMedication({
                            ...newMedication,
                            name: event.target.value,
                          });
                    }}
                  />
                </label>
                <label className="mt-4 flex items-center">
                  <p className="ml-2">{translate('brand_name')}</p>
                  <input
                    type="text"
                    className="ml-6 w-40 md:w-96 px-2 py-1 bg-background-2 text-text-2 font-bold rounded-sm focus:outline-none"
                    value={
                      editMode ? editMedication.brand : newMedication.brand
                    }
                    onChange={(event) => {
                      editMode
                        ? setEditMedication({
                            ...editMedication,
                            brand: event.target.value,
                          })
                        : setNewMedication({
                            ...newMedication,
                            brand: event.target.value,
                          });
                    }}
                  />
                </label>
                <div className="mt-4 flex">
                  <p className="ml-2 mt-1">{translate('dosage')}</p>
                  <div className="ml-6 grid gap-4 w-40 md:w-96 md:grid-cols-2 mb-4">
                    <label className="flex items-center">
                      <input
                        type="text"
                        className="w-full px-2 py-1 bg-background-2 text-text-2 font-bold rounded-sm focus:outline-none"
                        value={
                          editMode
                            ? editMedication.dosage
                            : newMedication.dosage
                        }
                        onChange={(event) => {
                          editMode
                            ? setEditMedication({
                                ...editMedication,
                                dosage: event.target.value,
                              })
                            : setNewMedication({
                                ...newMedication,
                                dosage: event.target.value,
                              });
                        }}
                      />
                    </label>
                  </div>
                </div>
                <label className="ml-16 flex items-center self-start">
                  <p className="ml-2 mr-1">{translate('fee')}</p>
                  <input
                    type="number"
                    className="ml-6 md:w-46 font-bold w-40 px-2 py-1 bg-background-2 text-text-2 rounded-sm focus:outline-none"
                    value={editMode ? editMedication.fee : newMedication.fee}
                    onChange={(event) => {
                      editMode
                        ? setEditMedication({
                            ...editMedication,
                            fee: event.target.value,
                          })
                        : setNewMedication({
                            ...newMedication,
                            fee: event.target.value,
                          });
                    }}
                  />
                </label>
              </div>
            </form>
            {medications.length > 0 && (
              <div className="mt-8">
                <h2 className="text-lg font-font-2 font-bold text-center">
                  {translate('medication_list')}
                </h2>
                <div className="mt-4 bg-gray-800 p-4 px-8 grid grid-cols-3 gap-x-8 gap-y-4">
                  {medications.map((medication) => (
                    <button
                      key={medication.id}
                      className="bg-background-2 text-text-5 p-2 focus:outline-none"
                      onClick={() => setEditMedication(medication)}
                    >
                      {medication.name}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>
      </main>
      <Loading message={translate('loading_medication_details')} ready={ready} />
    </>
  );
}
